import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["from", "enter", "update", "leave", "duration", "easing", "delay"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, Children } from 'react';
import { useConfig } from '../hooks/use-config';
import { useTransition } from '../utils/spring';
import { Animated } from './animated';
import { merge } from 'lodash';
export function TransitionSingle(_ref) {
  var children = _ref.children,
      show = _ref.show,
      configs = _ref.configs,
      target = _ref.target;
  var ref = useRef();

  var _useConfig = useConfig({
    configs: configs,
    target: target,
    getItemRef: function getItemRef() {
      return ref.current;
    }
  }),
      from = _useConfig.from,
      enter = _useConfig.enter,
      update = _useConfig.update,
      leave = _useConfig.leave,
      duration = _useConfig.duration,
      easing = _useConfig.easing,
      delay = _useConfig.delay,
      rest = _objectWithoutProperties(_useConfig, _excluded);

  var transitions = useTransition(show, _objectSpread(_objectSpread({}, rest), {}, {
    from: from,
    enter: enter,
    update: update,
    leave: leave,
    delay: delay,
    config: merge({}, rest === null || rest === void 0 ? void 0 : rest.config, {
      duration: duration,
      easing: easing
    })
  }));
  var child = children ? Children.only(children) : null;
  return transitions(function (style, item) {
    return item && /*#__PURE__*/React.createElement(Animated, {
      ref: ref,
      style: style
    }, child);
  });
}